import ResponsiveModal from "@/modules/common/components/ui-kit/modals/responsive-modal";
import { Box } from "@mui/material";
import "react-phone-input-2/lib/style.css";
import TelephoneDisplay from "@/modules/lead-page/new/components/sidebar/fields/telephone/telephone-display";
import TelephoneModal from "@/modules/lead-page/new/components/sidebar/fields/telephone/telephone-modal";
import { useTelephoneContext } from "@/modules/lead-page/new/hooks/telephone-context.hook";

const EditTelephone = () => {
  const { telephone } = useTelephoneContext();

  return (
    <>
      <TelephoneDisplay />

      <Box sx={{ zIndex: 1000 }}>
        <ResponsiveModal
          open={telephone?.editTelephoneModalOpen}
          onClose={() => {
            telephone.setEditTelephoneModalOpen(false);
            telephone.setTelephone("");
          }}
          snapPoints={[1]}
        >
          <TelephoneModal />
        </ResponsiveModal>
      </Box>
    </>
  );
};

export default EditTelephone;
